'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FoundationComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FoundationComponent = exports.FoundationComponent = function (_React$Component) {
  _inherits(FoundationComponent, _React$Component);

  function FoundationComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FoundationComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FoundationComponent.__proto__ || Object.getPrototypeOf(FoundationComponent)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'classList', {
      enumerable: true,
      writable: true,
      value: {}
    }), Object.defineProperty(_this, 'propsList', {
      enumerable: true,
      writable: true,
      value: {}
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FoundationComponent, [{
    key: 'createClassList',
    value: function createClassList(elementName) {
      var _this2 = this;

      var classes = new Set();
      this.classList[elementName] = {
        get: function get() {
          return (0, _classnames2.default)(elementName === 'root_' && _this2.props.className, [].concat(_toConsumableArray(classes)));
        },
        add: function add(className) {
          if (!classes.has(className)) {
            classes.add(className);
            _this2.setState({});
          }
        },
        remove: function remove(className) {
          if (classes.has(className)) {
            classes.delete(className);
            _this2.setState({});
          }
        }
      };
    }
  }, {
    key: 'createPropsList',
    value: function createPropsList(elementName) {
      var _this3 = this;

      var props = {};
      this.propsList[elementName] = {
        get: function get() {
          return props;
        },
        add: function add(propName, value) {
          props = Object.assign({}, props, {
            propName: value
          });
          _this3.setState({});
        },
        remove: function remove(propName) {
          delete props[propName];
          props = Object.assign({}, props);
          _this3.setState({});
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.foundation_ = this.getDefaultFoundation();
      this.syncWithDOM(this.props);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.syncWithDOM(this.props);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.foundation_ && this.foundation_.destroy();
      this.propsList = {};
      this.classList = {};
    }
  }, {
    key: 'syncWithDOM',
    value: function syncWithDOM(props) {}
  }, {
    key: 'getDefaultFoundation',
    value: function getDefaultFoundation() {}
  }]);

  return FoundationComponent;
}(React.Component);
